
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/caja.vue';
    import movil from './pc/caja.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
